/* eslint-disable jira/filename-case */

import type { ComponentType, FC, ComponentPropsWithRef } from 'react';
import withAnalyticsEvents, {
	type WithAnalyticsEventsProps,
} from '@atlaskit/analytics-next/withAnalyticsEvents';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import withAnalyticsContext from '@atlaskit/analytics-next/withAnalyticsContext';

type Callbacks<Props> = Record<keyof Props, string>;
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const map = (props: Callbacks<any>): Record<string, any> =>
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Object.keys(props).reduce<Record<string, any>>(
		// oxlint-disable-next-line oxc/no-accumulating-spread
		(result, key) => ({ ...result, [key]: { action: props[key] } }),
		{},
	);

/**
 * Augments component's callbacks with analytics event as the last attribute, but does fires them
 * @example
 * ```tsx
 * // adds componentName into AnalyticsContext and adds pre-backed 'clicked' event to onClick arguments
 *  const componentWithAnalytics('FooComponent', { onClick: 'clicked' })(Foo)
 */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
function componentWithAnalytics<InjectedCallbacks extends Callbacks<any>>(
	componentName: string,
	eventActions: InjectedCallbacks,
) {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	return function <T extends ComponentType<any>, Props = ComponentPropsWithRef<T>>(
		WrappedComponent: T,
	): FC<
		Omit<
			{
				[K in keyof Props]: K extends keyof InjectedCallbacks
					? (
							// @ts-expect-error TS2344: Type Props[K] does not satisfy the constraint (...args: any) => an
							...args: [...Parameters<Props[K]>, UIAnalyticsEvent]
							// @ts-expect-error TS2344: Type Props[K] does not satisfy the constraint (...args: any) => an
						) => ReturnType<Props[K]>
					: Props[K];
			},
			keyof WithAnalyticsEventsProps
		>
	> {
		// oxlint-disable-next-line typescript/consistent-type-assertions
		return withAnalyticsContext({ componentName })(
			withAnalyticsEvents(map(eventActions))(WrappedComponent),
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		) as any;
	};
}

export default componentWithAnalytics;
